import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import Button from '../button/Button';
import Grid from '../grid/Grid';
import Heading from '../heading/Heading';
import LazyImage from '../image/LazyImage';
import Box from '../layout/Box';
import Text from '../text/Text';
import Desktop from '../layout/Desktop';
import Mobile from '../layout/Mobile';
import Section from '../layout/Section';
import Container from '../layout/Container';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TwoColumnsHeading = styled(Heading).attrs({
  as: 'h2',
  $variant: ['h3', 'h2', 'h2', 'h2'],
  $mb: [24, 16, 16, 16],
  $styles: {
    maxWidth: [null, 455, 455, 455]
  }
}).withConfig({
  displayName: "TwoColumns__TwoColumnsHeading",
  componentId: "sc-bxylf6-0"
})({});
var TwoColumnsText = styled(Text).attrs({
  $variant: 'p1',
  $transparency: 0.3,
  $mb: [24, 40, 40, 40],
  $styles: {
    maxWidth: [null, 455, 455, 455]
  }
}).withConfig({
  displayName: "TwoColumns__TwoColumnsText",
  componentId: "sc-bxylf6-1"
})({});

var TwoColumns = function TwoColumns(_ref) {
  var headline = _ref.headline,
      content = _ref.content,
      button = _ref.button,
      image = _ref.image,
      _ref$isRtl = _ref.isRtl,
      isRtl = _ref$isRtl === void 0 ? false : _ref$isRtl;
  return /*#__PURE__*/_jsx(Section, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Grid, {
        isRtl: isRtl,
        columns: 2,
        children: [/*#__PURE__*/_jsx(Desktop, {
          children: /*#__PURE__*/_jsxs(Box, {
            children: [headline && /*#__PURE__*/_jsx(TwoColumnsHeading, {
              children: headline
            }), content && /*#__PURE__*/_jsx(TwoColumnsText, {
              children: content
            }), button && /*#__PURE__*/_jsx(Button, _objectSpread({}, button))]
          })
        }), /*#__PURE__*/_jsxs(Box, {
          children: [headline && /*#__PURE__*/_jsx(Mobile, {
            children: /*#__PURE__*/_jsx(TwoColumnsHeading, {
              children: headline
            })
          }), image && /*#__PURE__*/_jsx(Box, {
            $mb: [24, null, null, null],
            $styles: {
              position: 'relative',
              height: [325, 550, 550, 550],
              width: [325, 550, 550, 550]
            },
            children: /*#__PURE__*/_jsx(LazyImage, _objectSpread({}, image))
          }), /*#__PURE__*/_jsxs(Mobile, {
            children: [content && /*#__PURE__*/_jsx(TwoColumnsText, {
              children: content
            }), button && /*#__PURE__*/_jsx(Button, _objectSpread({}, button))]
          })]
        })]
      })
    })
  });
};

export default TwoColumns;